export const PACKAGE_NAME = 'jiraNavigationAppsSidebarEditionAwarenessUtils';

export const STORAGE_KEY = 'storageCache';

export const USAGE_LIMITS_BY_PRODUCT_CACHE_KEY = 'usageLimitsByProductCache';
export const USAGE_LIMITS_EXPIRY_MS = 24 * 60 * 60 * 1000; // One day
